import { getApiRequest } from 'api';
import { Parallel } from 'types/parallel';

export const getEducationalParallels = (): Promise<Parallel[]> => {
    return getApiRequest(`/edu/parallel/`);
};
